"use client";
import React, { useEffect, useState } from "react";
//import { fetchenquirydata } from '@packages/REST-API/rest-api';
import makeApiCall from "@packages/lib/server-actions/rest-api";
import API_URL from "@packages/lib/server-actions/api-urls";
// import { useRouter } from "next/navigation";
import {
  clickstreamForClicks,
  gaForCtaClicks,
  oldGAForCtaClicks,
} from "@packages/lib/utlils/commonFunction";
import { ClickstreamInterface } from "@packages/lib/utlils/clickstream";
import { ClickstreamConstants } from "@packages/shared-components/services/constants";
import ButtonLoader from "./ButtonLoader";
import { cleanUrl } from "@packages/lib/utlils/url-builder";
import { getCustomDomain } from "@packages/lib/utlils/common-function-server";
interface GetprospectusProps {
  enquiryProps: any;
  commonGAAttrs?: any;
  btnSize?: string;
  leafbtn?: any;
  btnName?: string;
  commonOldGAAttrs?: any;
}

const Getprospectus = ({
  enquiryProps,
  commonGAAttrs = {} as any,
  btnSize = "w-full",
  leafbtn,
  btnName,
  commonOldGAAttrs,
}: GetprospectusProps) => {
  const [url, setUrl] = useState<any>(null);
  // const router = useRouter();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  var csData: ClickstreamInterface = {} as ClickstreamInterface;
  csData.CTATitle = ClickstreamConstants.getProspectusCTA;
  csData.actionType = ClickstreamConstants.clickAction;
  csData.functionalityName =
    enquiryProps?.sponsoredListingFlag === "Y"
      ? ClickstreamConstants.sponsorListing
      : ClickstreamConstants.getProspectusCTA;
  useEffect(() => {
    if (url) {
      window.location.href = cleanUrl(url);
    }
  }, [url]);
  commonGAAttrs.click_text = csData.CTATitle;
  const handleExternalProspectus = async (
    externalUrl: string,
    response: any,
  ) => {
    csData.eventType = ClickstreamConstants.prospectusExternalEvent;
    csData.externalUrl = externalUrl;
    enquiryProps.url = externalUrl;
    enquiryProps.revenueValue = response?.webformPrice;
    commonGAAttrs.click_text = csData.CTATitle;
    gaForCtaClicks(
      enquiryProps,
      "prospectus_external",
      commonGAAttrs,
      response.cpeFlag,
    );
    await clickstreamForClicks(enquiryProps, csData, commonGAAttrs, "");
    window.open(externalUrl, "_blank");
  };

  const buildProspectusUrl = (response: any) => {
    const baseUrl = `/degrees/prospectus${enquiryProps?.collegeName ? `/${enquiryProps?.collegeName}-prospectus` : ""}${enquiryProps?.collegeId ? `/${enquiryProps?.collegeId}` : ""}${enquiryProps?.courseId ? `/${enquiryProps?.courseId}` : "/0"}${enquiryProps?.selectedSubject ? `/${enquiryProps?.selectedSubject}` : "/0"}`;

    if (process.env.PROJECT === "PGS") {
      return `/pgs/pgs_interactive.get_request_prospectus_prc?${enquiryProps?.collegeId ? `z=${enquiryProps?.collegeId}` : ""}${response?.orderItemId ? `&p_order_item_id=${response?.orderItemId}` : ""}&pageName=${enquiryProps?.pageName}`;
    }

    const sponsorParam = `sponsoredOrderItemId=${enquiryProps?.sponsoredListingFlag === "Y" ? enquiryProps?.orderItemId || "" : ""}`;
    const subOrderId = enquiryProps?.subOrderItemId
      ? `n-${enquiryProps?.subOrderItemId}`
      : "n-";

    const pageNameMap: Record<string, string> = {
      browsemoneypageresults: "sr",
      uniprofile: "contenthub",
      coursesearchresult: enquiryProps?.pageName,
      coursedetails: enquiryProps?.pageName,
      contenthub: enquiryProps?.pageName,
    };

    const pageName =
      pageNameMap[enquiryProps?.pageName] || enquiryProps?.pageName;
    const additionalParams =
      enquiryProps?.pageName === "browsemoneypageresults"
        ? `&manualBoostingFlag=${enquiryProps?.manualBoostingFlag || "N"}`
        : "";
    const nonAdvertiserFlag = !enquiryProps?.subOrderItemId
      ? "&nonAdvertiserFlag=Y"
      : "";

    return `${baseUrl}/${subOrderId}/order-prospectus.html?${sponsorParam}&pageName=${pageName}${additionalParams}${nonAdvertiserFlag}`;
  };

  const handleGetProspectus = async () => {
    setIsLoading(true);
    try {
      const getProspectusPayload = {
        suborderItemId: enquiryProps?.subOrderItemId,
        orderItemId: enquiryProps?.orderItemId,
        collegeId: enquiryProps?.collegeId,
        courseId: enquiryProps?.courseId,
        affiliateId: process.env.PROJECT === "Whatuni" ? 220703 : 607022,
        qualCode: enquiryProps?.qualCode,
      };
      commonGAAttrs.study_mode = enquiryProps?.studyMode;
      if (sessionStorage.getItem("veppleProviders")) {
        commonOldGAAttrs.data_label5 = "vepple_driven";
      }
      //const response = await fetchenquirydata(getProspectusPayload);
      const response = await makeApiCall({
        url: `${process.env.NEXT_PUBLIC_DOMSERVICE_API_DOMAIN}/${API_URL?.getEnquiryDetails}`,
        method: "POST",
        queryParams: {},
        body: getProspectusPayload,
        headers: {
          "x-api-key": `${process.env.NEXT_PUBLIC_DOMSERVICE_X_API_KEY}`,
        },
      });

      if (response?.stdGetProspectusUrl) {
        csData.eventType = ClickstreamConstants.prospectusExternalEvent;
        csData.externalUrl = response.stdGetProspectusUrl;
        enquiryProps.revenueValue = response?.webformPrice;
        enquiryProps.url = response.stdGetProspectusUrl;
        gaForCtaClicks(enquiryProps, "prospectus_external", commonGAAttrs);
        enquiryProps.event = "prospectus_external";
        oldGAForCtaClicks(
          enquiryProps,
          "Get prospectus",
          enquiryProps.url,
          enquiryProps.event,
          commonOldGAAttrs,
          response?.cpeFlag,
          response?.digitalProspectus,
        );
        await clickstreamForClicks(enquiryProps, csData, commonGAAttrs, "");
        window.open(response.stdGetProspectusUrl, "_blank");
        setIsLoading(false);
      } else if (response?.requestProspectusWebform) {
        csData.eventType = ClickstreamConstants.prospectusExternalEvent;
        csData.externalUrl = response.requestProspectusWebform;
        enquiryProps.revenueValue = response?.webformPrice;
        enquiryProps.url = response.requestProspectusWebform;
        gaForCtaClicks(enquiryProps, "prospectus_external", commonGAAttrs);
        enquiryProps.event = "prospectus_external";
        oldGAForCtaClicks(
          enquiryProps,
          "Get prospectus",
          enquiryProps.url,
          enquiryProps.event,
          commonOldGAAttrs,
          response?.cpeFlag,
          response?.digitalProspectus,
        );
        await clickstreamForClicks(enquiryProps, csData, commonGAAttrs, "");
        window.open(response.requestProspectusWebform, "_blank");
        setIsLoading(false);
      } else if (
        response?.requestProspectusEmail ||
        response?.digitalProspectus?.toLowerCase() === "y"
      ) {
        const digitalFlag = response.digitalProspectus === "Y";
        const prospectusUrl = buildProspectusUrl(response);
        enquiryProps.revenueValue = response?.emailPrice;
        enquiryProps.url = getCustomDomain() + prospectusUrl;
        csData.eventType = digitalFlag
          ? ClickstreamConstants.digitalProspectusEvent
          : ClickstreamConstants.physicalProspetcusEvent;
        csData.functionalityName = digitalFlag
          ? "DOWNLOAD PROSPECTUS"
          : "Get prospectus";
        enquiryProps.event = "prospectus form";
        gaForCtaClicks(
          enquiryProps,
          "prospectus_request",
          commonGAAttrs,
          response.cpeFlag,
          response.digitalProspectus,
        );
        oldGAForCtaClicks(
          enquiryProps,
          "Get prospectus",
          enquiryProps.url,
          "prospectus_request",
          commonOldGAAttrs,
          response?.cpeFlag,
          response?.digitalProspectus,
        );
        await clickstreamForClicks(
          enquiryProps,
          csData,
          commonGAAttrs,
          response?.digitalProspectus,
        );
        setUrl(prospectusUrl);
      }
    } catch (error) {
      console.error("Error fetching enquiry data:", error);
      setIsLoading(false);
    }
  };

  function getSponsorOrderItemId() {
    return `sponsoredOrderItemId=${enquiryProps?.sponsoredListingFlag === "Y" ? enquiryProps?.orderItemId || "" : ""}`;
  }

  return (
    <>
      {leafbtn ? (
        <button
          type="button"
          onClick={handleGetProspectus}
          className="flex gap-[6px] items-center btn btn-primary rtfcustom-link hover:no-underline px-[20px] py-[10px] w-fit !no-underline"
        >
          {ClickstreamConstants.getProspectusCTA}
          {isLoading ? (
            <svg
              className="animate-spin h-[16px] w-[16px]"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
              />
            </svg>
          ) : (
            <svg
              width="16"
              height="14"
              viewBox="0 0 16 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.55556 1.55554L15 6.99999M15 6.99999L9.55555 12.4444M15 6.99999L1 6.99999"
                stroke="#fff"
                strokeWidth="1.67"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}
        </button>
      ) : (
        <button
          id="gp-btn"
          type="button"
          className={`btn btn-tertiary flex justify-center items-center ${btnSize}`}
          onClick={handleGetProspectus}
        >
          <ButtonLoader isLoading={isLoading}>
            {btnName || ClickstreamConstants.getProspectusCTA}
          </ButtonLoader>
        </button>
      )}
    </>
  );
};

export default Getprospectus;
